import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnButton from "@shared/components/SnButton";
import { showPopupModal } from "@widgets/CommonModal";
import SN_SAL_EST_REG_001_POP_CARD02 from "./SN_SAL_EST_REG_001_POP_CARD02";
import SN_SAL_EST_REG_001_POP_CARD03 from "./SN_SAL_EST_REG_001_POP_CARD03";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_EST_REG_001_POP_CARD01 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns1, setColums1] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [gridApiRefH.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp(
            "SN_SAL_EST_REG_001_POP_CARD01",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setTimeout(() => {
            onSearch();
          }, 50);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo, selectedData]);

    //#region Button Event
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_sal_est_reg_001_POP_CARD01_01",
            params: searchRef.current.getFormdata(),
          };

          setDataSource1([]);
          const data: any = await fnGetDataSet(params);
          setDataSource1(data[0]);

          if (data[0] && data[0].length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));

            gridApiRefH.current.selectAndFocusRow(0);
          }

          gridApiRefH.current.resetUpdate();
        } catch (error) {}
      };
      await fetchdatasource();
    };

    const onAddRow = async () => {
      try {
        const newRow = {};
        gridApiRefH.current?.addRow(newRow);
      } catch (error) {}
    };

    const onGridBtnsClick = async (id: string) => {
      if (id === "aButton_Add") {
        const component = (
          <SN_SAL_EST_REG_001_POP_CARD02 selectedData={selectedData} />
        );

        const result = await showPopupModal({
          title: "담당자 등록",
          children: component,
          width: "51%",
          height: "80%",
          // height: "55%",
        });

        if (!result || result === "close") return;
        const headerResult = result[0];
        const focusedCellH = gridApiRefH.current.api.getFocusedCell();
        if (focusedCellH) {
          const rowNode = gridApiRefH.current.api.getDisplayedRowAtIndex(
            focusedCellH.rowIndex
          );
          if (headerResult[0]) {
            headerResult[0].nm_source &&
              gridApiRefH.current.setValue(
                rowNode,
                "nm_cust",
                headerResult[0].nm_source
              );
          }
        }
      }

      if (id === "aButton_Modify") {
        const gridApiH = gridApiRefH.current.api;
        const focusedCell = gridApiH.getFocusedCell();
        if (!focusedCell) {
          await showDialog("alter", "신규행을 추가하시기 바랍니다.");
          return;
        }

        const rowNode = gridApiH.getDisplayedRowAtIndex(focusedCell.rowIndex);
        const selectedRowData = rowNode.data; // full row object

        const component = (
          <SN_SAL_EST_REG_001_POP_CARD03
            selectedData={{ ...selectedRowData, ...selectedData }}
          />
        );

        const result = await showPopupModal({
          title: "담당자 수정",
          children: component,
          width: "51%",
          height: "55%",
        });

        if (!result || result === "close") return;
      }
    };
    //#endregion

    return (
      <div style={{ position: "relative" }}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div>
          <div style={{ height: "60vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridApiRefH} // Grid Name
              columnConfig={columns1} // 컬럼 설정 전달
              rowData={dataSource1} // DataSource
              rowSelection="single" // 행 선택 모드(단일)
              isEditable={false} // 수정 가능 여부
              enableAddRow={false} // 행 추가 여부
              title=" "
              header={
                <div>
                  <SnButton
                    text={"추가"}
                    onClick={() => {
                      onGridBtnsClick("aButton_Add");
                    }}
                  />
                  <SnButton
                    text={"수정"}
                    onClick={() => {
                      onGridBtnsClick("aButton_Modify");
                    }}
                  />
                </div>
              }
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_SAL_EST_REG_001_POP_CARD01;
